/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
//@ts-ignore
import { sanitizeUrl } from '@intercom/pulse/lib/sanitize';

export default class FrameLoginRoute extends Route {
  model(params: { redirect_url: string; can_request_storage_access: string }) {
    let decodedUrl = decodeURIComponent(params.redirect_url);

    if (!this.isValidRedirectUrl(decodedUrl)) {
      throw new Error('Invalid redirect URL');
    }

    return {
      redirect_url: sanitizeUrl(decodedUrl).string,
      can_request_storage_access: params.can_request_storage_access,
    };
  }

  private isValidRedirectUrl(url: string): boolean {
    try {
      let parsedUrl = new URL(url);

      // Only allow http/https protocols to prevent javascript: and other dangerous protocols
      if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
        return false;
      }

      // Ensure redirect URL origin matches current origin for security
      return parsedUrl.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }
}
